import axios from 'axios';

function createCacheAdapter(fetch, ttl) {
  // creates cache adapter for axios
  var _require = require('axios-cache-interceptor'),
      setupCache = _require.setupCache;

  setupCache(fetch, {
    ttl: ttl * 1000
  });
}

function createFetcher(_ref) {
  var ttl = _ref.ttl;

  var _fetch = axios.create({
    proxy: false
  });

  if (ttl && ttl > 0) {
    createCacheAdapter(_fetch, ttl);
  }

  return _fetch;
}

var fetch = /*#__PURE__*/createFetcher({});

export { createCacheAdapter, fetch };
//# sourceMappingURL=fetch.esm.js.map
